/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import EnvEnum from './env-enum';

// TODO Mohlo by se odstranit opakování napříč různými prostředími (multi-platformní kód).
// - /util.js parseEnv.
// - Budou asi hlavně problémy s importy.
/**
 * Utility pro práci s číselníkem prostředí.
 */
class EnvUtil {
  /**
   * Vygeneruje textovou reprezentaci prostředí.
   * @param {EnvEnum|null} value Prostředí z číselníku.
   * @returns {string|null} Prostředí jako text.
   * @static
   */
  static generate(value) {
    switch (value) {
      case EnvEnum.DEV:
        return 'development';
      case EnvEnum.PROD:
        return 'production';
      default:
        return null;
    }
  }

  /**
   * Načte prostředí z textového řetězce.
   * @param {string|null} value Prostředí jako text.
   * @returns {EnvEnum|null} Prostředí z číselníku.
   * @static
   */
  static parse(value) {
    switch (value) {
      case 'dev':
      case 'development':
        return EnvEnum.DEV;
      case 'prod':
      case 'production':
        return EnvEnum.PROD;
      default:
        return null;
    }
  }
}

export default EnvUtil;
